import React from 'react';
import { useFetchWithCache } from '../hooks/useFetchWithCache';
import LoadingSpinner from '../components/LoadingSpinner';
import { PageBanner, BannerContent, Eyebrow, SectionTitle, GoldDivider, SectionLead } from './styles/Shared.styles';
import { Section, Inner, Grid, MemberCard, Empty } from './styles/Team.styles';

const Team = () => {
  const { data: team, loading } = useFetchWithCache('/team');

  if (loading && !team) return <LoadingSpinner fullPage />;
  const t = team || {};
  const members = Array.isArray(t.members) ? t.members : [];

  return (
    <>
      <PageBanner $src={t.bannerImage}>
        <BannerContent>
          <span className="eyebrow">Leadership</span>
          <h1>{t.title || 'Our Team'}</h1>
          {t.description && <p>{t.description}</p>}
        </BannerContent>
      </PageBanner>

      <Section>
        <Inner>
          <Eyebrow style={{ paddingLeft: 0 }}>Meet The Team</Eyebrow>
          <SectionTitle>The people behind <span>Ehcerex</span></SectionTitle>
          <GoldDivider $center />
          <SectionLead style={{ margin: '0 auto' }}>
            {t.description || 'The leaders driving every company in the Ehcerex group.'}
          </SectionLead>

          {members.length === 0 ? (
            <Empty>Team members will be added soon.</Empty>
          ) : (
            <Grid>
              {members.map((m, i) => (
                <MemberCard key={i}>
                  <div className="image">
                    {m.image ? (
                      <img src={m.image} alt={m.name} />
                    ) : (
                      <div className="ph">{(m.name || '?').charAt(0)}</div>
                    )}
                  </div>
                  <div className="body">
                    {m.role && <div className="role">{m.role}</div>}
                    <h3>{m.name}</h3>
                    {m.bio && <p>{m.bio}</p>}
                  </div>
                </MemberCard>
              ))}
            </Grid>
          )}
        </Inner>
      </Section>
    </>
  );
};

export default Team;
